require('../../modules/es6.object.prevent-extensions');
module.exports = require('../../modules/_core').Object.preventExtensions;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/prevent-extensions.js
// module id = 805
// module chunks = 1